import sortBy from 'lodash/sortBy';
import Resources from '../../../helpers/resources';
import DateParamHelper from '../../../helpers/date-param-helper';
import errorsActions from '../../app/errors/errors-actions';
import { ENDPOINT_PATH_PARTICIPATION } from '../../../helpers/constants';

export const PARTICIPATION_CLASS_RETRIEVED = 'PARTICIPATION_CLASS_RETRIEVED';

function getParticipationData(classroomId, selectedDateFilter) {
    return (dispatch) =>
        Resources.singleClassReport
            .get({
                reportType: ENDPOINT_PATH_PARTICIPATION,
                ...DateParamHelper.getDateTypePath(selectedDateFilter),
                classroomId
            })
            .withParams(DateParamHelper.getDateQueryParams(selectedDateFilter))
            .send()
            .then((payload) => {
                if (payload.valid) {
                    dispatch({
                        type: PARTICIPATION_CLASS_RETRIEVED,
                        payload: mapParticipationData(payload.data)
                    });
                } else {
                    dispatch(
                        errorsActions.addError(PARTICIPATION_CLASS_RETRIEVED)
                    );
                }
            });
}

function mapParticipationData(data) {
    const {
        classroomName,
        teachers,
        certificateDetails,
        newCertificateDetails,
        classroomGroupParticipations
    } = data;

    let teacherName = '';
    if (teachers.length > 0) {
        if (teachers.length > 1) {
            teacherName = `${teachers.length} Teachers`;
        } else {
            const teacher = teachers[0];
            teacherName = `${teacher.title} ${teacher.firstName} ${teacher.lastName}`;
        }
    }

    let mappedGroupData = classroomGroupParticipations.map((groupData) => ({
        id: groupData.id,
        name: groupData.name,
        courseName: groupData.courseName,
        certificateDetails: groupData.certificateDetails,
        newCertificateDetails: groupData.newCertificateDetails,
        usage: mapUsage(groupData),
        studentUsageDetails: mapStudentsUsage(groupData),
        upfCourseId: groupData.upfCourseId,
        upfCourseName: groupData.upfCourseName,
        upfCoursePublicationName: groupData.upfCoursePublicationName,
        upfFullName: `${groupData.upfCoursePublicationName} - ${groupData.upfCourseName}`,
        encryptedUserProfileId: groupData.encryptedUserProfileId,
        userProfileId: groupData.userProfileId
    }));
    mappedGroupData = sortBy(mappedGroupData, [
        (group) => (group.name === 'Default Group' ? 0 : 1),
        'name'
    ]);

    return {
        classroomName,
        teacherName,
        certificateDetails,
        newCertificateDetails,
        usage: mapUsage(data),
        classroomGroupParticipations: mappedGroupData
    };
}

function mapUsage(data) {
    const usage = {
        id: 0,
        ...data.points,
        ...data.accessDetails,
        totalPoints: data.points.total
    };
    delete usage.total;
    return [usage];
}

function mapStudentsUsage(groupData) {
    const studentsUsage = groupData.studentUsageDetails.map((student) => {
        const mappedStudent = { ...student };
        mappedStudent.id = student.userProfileId;
        mappedStudent.fullName = `${student.lastName}, ${student.firstName}`;
        mappedStudent.groupId = groupData.id;
        delete mappedStudent.userProfileId;
        return mappedStudent;
    });
    return sortBy(studentsUsage, ['lastName', 'firstName']);
}

export default {
    getParticipationData
};



// WEBPACK FOOTER //
// ./containers/participation/single-class/single-class-actions.js